import React from 'react';
import { Area, Box } from '@ublend-npm/aulaui-core';
import NavigationBackHeader from '@app/components/presentational/common/NavigationBackHeader/NavigationBackHeader';

const PageView: React.FC = ({ children }) => {
  return (
    <Box sx={{ padding: 2 }}>
      <Box sx={{ marginBottom: 1, marginLeft: -1 }}>
        <NavigationBackHeader onClick={() => window.history.back()} />
      </Box>

      <Area
        rounded
        sx={{
          padding: 2,
          '& .inner-messages-list': {
            height: 'calc(100vh - 278px)',
            '-webkit-height': 'calc(100dvh - 278px)',
          },
        }}
      >
        {children}
      </Area>
    </Box>
  );
};

export default PageView;
